import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import { isRingo } from 'shared/domainUtils'

import {beginSignIn as beginSignInAction,
    beginJoin as beginJoinAction} from 'actions/creators/Auth';

const messages = defineMessages({
    join: {
        id: 'header.signin.join_title',
        defaultMessage: 'Регистрация'
    },
    signin: {
        id: 'header.signin.title',
        defaultMessage: 'Вход'
    }
});

class SignIn extends React.Component {
    static propTypes = {
        beginSignInAction: PropTypes.func.isRequired,
        beginJoinAction: PropTypes.func.isRequired
    };

    constructor (props, context) {
        super(props, context);

        this._handleLogInClick = this._handleLogInClick.bind(this);
        this._handleJoinClick = this._handleJoinClick.bind(this);
    }

    _handleLogInClick(e) {
        e.preventDefault();
        this.props.beginSignInAction();
    }

    _handleJoinClick(e) {
        e.preventDefault();
        this.props.beginJoinAction();
    }

    render() {
        return (
            <ul className="header--auth__list">
                {isRingo ? null : (
                <li className="header--auth__item">
                    <a href="#" className="header--auth__link" onClick={this._handleJoinClick}>
                        <FormattedMessage {...messages.join}/>
                    </a>
                </li>
                )}
                <li className="header--auth__item">
                    <a href="#" className="header--auth__link" onClick={this._handleLogInClick}>
                        <FormattedMessage {...messages.signin} />
                    </a>
                </li>
            </ul>
        );
    }
}

function select() {
    return {};
}

export default connect(select, {beginSignInAction, beginJoinAction})(SignIn);



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/SignIn.jsx